import { render } from "./PageNotFound.vue?vue&type=template&id=2aedfead"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sharesight_partner_app/sharesight_partner_app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__